import React, { useState } from 'react'

import { t } from 'i18n'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import CloseRoundedIcon from '@material-ui/icons/CloseRounded'
import { CheckboxField } from 'components/formik'
import HighLevelError from 'components/formik/error'
import IconButton from 'components/iconButton'

const useStyles = makeStyles((theme) => ({
  termsError: {
    '& > p': {
      fontSize: '0.857rem',
      fontWeight: 400
    }
  },
  dialogTitle: {
    padding: theme.spacing(5, 6, 0, 3),
    borderBottomColor: theme.palette.background.default,
    borderBottomStyle: 'solid',
    borderBottomWidth: 1
  },
  heading: {
    fontWeight: theme.palette.inputs.label.semibold
  },
  content: {
    fontWeight: theme.palette.inputs.label.regular,
    whiteSpace: 'pre-wrap'
  },
  actions: {
    padding: theme.spacing(2, 3),
    backgroundColor: theme.palette.grey[100]
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(3),
    top: theme.spacing(3),
    color: theme.palette.grey[300]
  }
}))

const TermsAndConditions: React.FC<{ setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void }> = ({ setFieldValue }) => {
  const classes = useStyles()
  const [open, setOpen] = useState(false)
  const handleOpen = (event: React.MouseEvent) => {
    event.preventDefault()
    setOpen(true)
  }
  const handleCloseWithAccept = () => {
    setOpen(false)
    setFieldValue('acceptTermsAndConditions', true)
  }
  const handleClose = () => setOpen(false)
  const checkboxLabel = (
    <>
      <a href='#' rel='noopener noreferrer' onClick={handleOpen}>
        {t('sign_up.credentials_form.accept_terms_and_conditions_label')}
      </a>
      <span aria-hidden='true' className='MuiFormLabel-asterisk Mui-error'>
         *
      </span>
    </>
  )
  return (
    <>
      <CheckboxField name='acceptTermsAndConditions' label={checkboxLabel} CheckboxProps={{}} />
      <div className={classes.termsError}>
        <HighLevelError name='acceptTermsAndConditions' />
      </div>
      <Dialog open={open}>
        <DialogTitle className={classes.dialogTitle} disableTypography>
          <Typography variant='h3' component='h3' className={classes.heading}>
            {t('sign_up.credentials_form.terms_and_conditions_title')}
          </Typography>
          <IconButton aria-label='close' className={classes.closeButton} onClick={handleClose} color='transparent'>
            <CloseRoundedIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent className={classes.content}>{t('sign_up.credentials_form.terms_and_conditions')}</DialogContent>
        <DialogActions className={classes.actions}>
          <Grid container justifyContent='flex-end' spacing={3}>
            <Grid item>
              <Button variant='outlined' color='primary' onClick={handleCloseWithAccept}>
                {t('sign_up.credentials_form.terms_and_conditions_accept')}
              </Button>
            </Grid>
            <Grid item>
              <Button variant='outlined' color='secondary' onClick={handleClose}>
                {t('close')}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default TermsAndConditions
